import config from 'config';
import firebaseConfig from 'firebaseConfig';
import { initializeApp } from 'firebase/app';
import errorAction from 'shared/utils/errorAction';
import { getMessaging, onMessage } from 'firebase/messaging';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { getLanguage, isRtl } from 'modules/language/selectors/language';
import { clearModalQueue } from 'modules/messageSystem/actions/clearModalQueue';

import createAction from './';
import { registerPushToken } from './registerPushToken';
import { workerRegistration } from './serviceWorkerRegistration';


const CREATE_FIREBASE = createAsyncAction(createAction('CREATE_FIREBASE'));

const postMessageTry = message =>
  navigator.serviceWorker.ready
    .then(req => req.active.postMessage(JSON.stringify(message)))
    .catch(() => setTimeout(() => postMessageTry(message), 1000));

export const createFirebase = () => (dispatch, getState) => {
  const state = getState();

  dispatch({ type: CREATE_FIREBASE.pending });

  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);

  const message = {
    rtl: isRtl(),
    language: getLanguage(),
    refreshToken: state.session.refreshToken.value,
    apiServerLink: config.api_server,
    organizationToken: state.auth.organizations.selectedOrganizationToken,
    externalUserId: state.auth.userInfo.secondaryLoginData.externalId,
  };

  return dispatch(workerRegistration())
    .then(() => dispatch(registerPushToken(messaging)))
    .then(() => onMessage(messaging, payload => console.log('Firebase Message received. ', payload)))
    .then(() => navigator.serviceWorker.ready)
    .then(() => navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data.msg === 'declineConsultation') dispatch(clearModalQueue());
      }))
    .then(() => {
      postMessageTry(message);
      return dispatch({ type: CREATE_FIREBASE.success });
    })
    .catch(err => dispatch(errorAction(CREATE_FIREBASE.failure, err)));
};
